import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import type { AccountingProvider } from '../../../../../services/accountingIntegration';
import { PROVIDER_LABELS } from './accountingIntegrationUi';

interface Props {
  onHandled: () => void;
}

function parseOAuthProvider(value: string | null): AccountingProvider | null {
  if (value === 'xero' || value === 'quickbooks') return value;
  return null;
}

export function AccountingOAuthCallbackHandler({ onHandled }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const oauthResult = searchParams.get('accounting_oauth');
    if (!oauthResult) return;

    const provider = parseOAuthProvider(searchParams.get('provider'));
    const providerLabel = provider ? PROVIDER_LABELS[provider] : 'Accounting software';

    if (oauthResult === 'success') {
      toast.success(`${providerLabel} connected successfully`);
      onHandled();
    } else if (oauthResult === 'error') {
      toast.error(`Could not connect ${providerLabel}. Try again or contact support.`);
    }

    const next = new URLSearchParams(searchParams);
    next.delete('accounting_oauth');
    next.delete('provider');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, onHandled]);

  return null;
}
